import { IGatsbyImageData } from 'gatsby-plugin-image';
import { ContentfulRichTextGatsbyReference } from '@vhub/gatsby-source-contentful/rich-text';
import { ContentfulImageAsset } from '../types/Contentful.types';

export const getImageSrcFromGatsbyImageData = (
  gatsbyImageData: IGatsbyImageData
) => {
  if (gatsbyImageData.images.fallback?.src) {
    return gatsbyImageData.images.fallback?.src;
  } else if (gatsbyImageData.images?.sources?.[0].srcSet) {
    return gatsbyImageData.images?.sources?.[0].srcSet.substring(
      0,
      gatsbyImageData.images?.sources?.[0].srcSet.indexOf(' ')
    );
  } else {
    return '';
  }
};

export const removeImageSizeParameters = (imageUrl: string) => {
  const parts = imageUrl.split('?');

  if (!parts[1]) {
    return imageUrl;
  }

  const regex = /fm=([^&]+)/;
  const match = parts[1].match(regex);

  if (!match) {
    return parts[0];
  }

  return parts[0] + '?' + match[0];
};

/**
 * Checks if the given reference is a Contentful image asset.
 *
 * @returns A boolean indicating whether the reference is a Contentful image asset.
 */
export const isContentfulImageAsset = (
  ref: ContentfulRichTextGatsbyReference
): ref is ContentfulImageAsset => {
  return (
    ref.__typename === 'ContentfulAsset' &&
    (Boolean((ref as ContentfulImageAsset).gatsbyImageData) ||
    Boolean((ref as ContentfulImageAsset).file.contentType === 'image/svg+xml'))
  );
};
